import React, { useEffect, useState } from "react";
// import "./CastingDirectorDashboard.css";
import { getAppliedRoleListForDrCr } from "../../../services/api";
import { Link, useNavigate } from 'react-router-dom';
import { Camera } from "lucide-react";

const CastingDirectorDashboard = () => {
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await getAppliedRoleListForDrCr();

      const finalData = res?.data?.data || [];

      console.log("FINAL ARRAY:", finalData);

      setApplications(finalData);
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();
}, []);

  return (
    <div className="cd-dashboard-wrapper">
      <div className="cd-main-section">

        {/* HEADER */}
        <div className="cd-header-row">
            <h1 className="cd-main-title">Casting Dashboard</h1>

            <button
                className="cd-post-btn"
                onClick={() => navigate('/dashboard/post-roles')}
            >
                + Post New Role
            </button>
        </div>

        {/* STATS */}
        <div className="cd-stats-row">
          <div className="cd-stat-box">
            <div className="cd-icon red">🎁</div>
            <div>
              <h2>1</h2>
              <p>Active Roles</p>
            </div>
          </div>

          <div className="cd-stat-box">
            <div className="cd-icon red">👥</div>
            <div>
              <h2>0</h2>
              <p>Total Applicants</p>
            </div>
          </div>

          <div className="cd-stat-box">
            <div className="cd-icon red">⭐</div>
            <div>
              <h2>12</h2>
              <p>Shortlisted</p>
            </div>
          </div>
        </div>

       

        <div className="cd-section-header">
            <h2>My Active Roles</h2>

            <Link
                to="/dashboard/roles"
                style={{
                cursor: 'pointer',
                background: 'red',
                padding: '4px 10px',
                borderRadius: '5px',
                color: '#fff',
                textDecoration: 'none'
                }}
            >
                View All
            </Link>
        </div>



<div className="cd-role-box">

  <div className="cd-role-left">
    <div className="cd-role-icon">🎥</div>
    <span className="cd-role-title">Required Male Actor</span>
  </div>

  <div className="cd-role-right">

    <div className="cd-app-count">
      <strong>0</strong>
      <span>Applicants</span>
    </div>

    <span className="cd-open-badge">Open</span>

    <span className="cd-arrow">›</span>

  </div>

</div>


<h2 className="cd-title">Auditions</h2>

<div className="audition-wrapper">
  <div className="table-scroll">
    <table className="audition-table">
      <thead className="custom-thead">
      
      {/* <thead style={{background:'#1a1a1a !important'}}> */}
        <tr >
          <th>TALENT</th>
          <th>ROLE</th>
          <th>PROJECT</th>
          <th>TYPE</th>
          <th>STATUS</th>
        </tr>
      </thead>

      <tbody>
        {applications.length > 0 ? (
          applications.slice(0, 5).map((app, i) => (
            <tr key={i}>
              <td className="bold">{app.candidateName}</td>
              <td>{app.c_roleName}</td>
              <td>{app.projectName}</td>
              <td>
                <span className="live">{app.bookingType}</span>
              </td>
              <td>{app.result}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No applications found</td>
          </tr>
        )}
      </tbody>

    </table>
  </div>
  </div>


        {/* <h2 className="cd-title">Auditions</h2>

<div className="audition-wrapper">
  <div className="table-scroll">
    <table className="audition-table">
      
      <thead>
        <tr>
          <th>TALENT</th>
          <th>ROLE</th>
          <th>PROJECT</th>
          <th>TYPE</th>
          <th>STATUS</th>
        </tr>
      </thead>

      <tbody>
        {applications.length > 0 ? (
          applications.slice(0, 5).map((app, i) => (
            <tr key={i}>
              <td className="bold">{app.talent_name}</td>
              <td>{app.c_role_name}</td>
              <td>{app.c_project_name}</td>
              <td>
                <span className="live">{app.c_audition_type}</span>
              </td>
              <td>{app.c_R_Status}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No applications found</td>
          </tr>
        )}
      </tbody>

    </table>
  </div>
</div> */}

      </div>
    </div>
  );
};

export default CastingDirectorDashboard;